module.exports = __webpack_public_path__ + "media/images/products/IMG_20210704_164046_HDR-removebg-preview-79c9165514c46587359b98f71290fede.png";